<script setup>
import { ref, reactive, onMounted} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CryptoJS from 'crypto-js';
import axios from 'axios'
import Swal from 'sweetalert2';

const url = process.env.VUE_APP_API_URL;
const apikey = process.env.VUE_APP_SECRET_KEY;
const cryptKey = process.env.VUE_APP_CRYPT;

const KEY = cryptKey; // Debe coincidir con el KEY en Java
const SALT = cryptKey; // Debe coincidir con el SALT en Java
const ITERATION_COUNT = 65536; // Debe coincidir con el ITERATION_COUNT en Java
const KEY_LENGTH = 256; // Debe coincidir con el KEY_LENGTH en Java

// Función para generar la clave secreta basada en la clave, sal y parámetros de iteración
function generateKey(secret, salt) {
  const key = CryptoJS.PBKDF2(secret, CryptoJS.enc.Utf8.parse(salt), {
    keySize: KEY_LENGTH / 32,
    iterations: ITERATION_COUNT
  });
  return key.toString(CryptoJS.enc.Hex);
}

// Función para desencriptar el valor
function decryptAES(ciphertext) {
  // Generar clave secreta
  const keyHex = generateKey(KEY, SALT);
  const key = CryptoJS.enc.Hex.parse(keyHex);

  // Decodificar el texto cifrado en Base64
  const encryptedData = CryptoJS.enc.Base64.parse(ciphertext);
  const iv = CryptoJS.lib.WordArray.create(encryptedData.words.slice(0, 4)); // IV es los primeros 16 bytes (4 palabras de 32 bits)
  const encrypted = CryptoJS.lib.WordArray.create(encryptedData.words.slice(4)); // Los datos cifrados son el resto

  // Desencriptar
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encrypted },
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
}


const persona = reactive([]);
const idExpediente = ref();
const episodiosHistoricos = reactive([]);
const isLoading = ref(true); // Estado de carga
const head = {
        'api-key': apikey       
      }
const route = useRoute();
const router = useRouter();
const encryptedData = ref('');

onMounted(async () => {
  window.scrollTo(0, 0);
  isLoading.value = true; // Iniciar carga
  
  try {
    let rawEncryptedData = route.query.id;

    // Reemplaza los espacios con "+" antes de decodificar
    rawEncryptedData = rawEncryptedData.replace(/ /g, '+');
    encryptedData.value = decodeURIComponent(rawEncryptedData);

    if(encryptedData.value){
      //const idPersona = await descifrar(encryptedData.value,cryptKey);
      const idPersona = decryptAES(encryptedData.value);

      //console.log(idPersona)
      
      persona.value = await buscaPersona(idPersona);
      if(persona.value){
        idExpediente.value = persona.value.expedienteId;
        episodiosHistoricos.value = await fetchDataExamenes(idExpediente.value);
      }
    }
  } catch (error) {
    console.error('Error al cargar datos:', error);
  } finally {
    isLoading.value = false; // Finalizar carga
  }
  
  
  
});

const error = ref('');

// *************--------------FUNCIONES---------------**************

const tipoExamenDesc = (tipoExamen_key) => {
    switch (tipoExamen_key) {
    case 1:
      return "EXAMEN PSICOFISICO INTEGRAL";
      
    case 2:
    return "EXAMEN MEDICO EN OPERACION";
    
    case 3:
    return "EXAMEN TOXICOLOGICO";
    
    case 9:
    return "EXAMEN POST-ACCIDENTE";
    
    default:
    return "EXAMEN PSICOFISICO INTEGRAL";
    
  }
}


const rutaPersona= `${url}/personaCita/getById/`;

const buscaPersona = async (idPersona) => {

    try{
        
      const response = await axios.get(`${rutaPersona}${idPersona}`,{  
      headers: head
    },);   

      if(response.data.status=="OK" && response.data.data!=null){
        return response.data.data;
      }else{
        //console.log('Error positivo al recuperar la persona: ',response.data.error_msg);
        isLoading.value = false;
        Swal.fire("Error", 'No se pudo obtener la información de la persona', "error");
        return null;
      }
      
    }catch(error){
        console.error('Error al usar endpoint con la ruta:', rutaPersona, 'Descripción de error:', error);
        isLoading.value = false;
        Swal.fire(
                  "Error al obtener datos de persona",
                  'Código de estado:'+ error,
                  "error"
                );
        return null;
    }
};



const rutaObtieneExamenes = `${url}/expedientes/consultar`;

const fetchDataExamenes = async (idExpediente) => {
  let cuerpoExpediente = { idExpediente: idExpediente};
  
  try {
    const response = await axios.post(rutaObtieneExamenes,cuerpoExpediente,{  
      headers: head
    },
  );
    
    
    // Asignar los datos JSON a la variable
    if(response.data.data !== null){
      return response.data.data.
      sort((a, b) => {
          if (a.numeroExamen < b.numeroExamen) return 1;
          if (a.numeroExamen > b.numeroExamen) return -1;
          return 0;
        });

    }else if(response.data.status.toUpperCase()==="ERROR"){
      console.error('Error al usar el servicio ', rutaObtieneExamenes, " Descripción de error: ",response.data.error_msg );
      isLoading.value = false;
      Swal.fire(
                  "Los episodios no se pudieron obtener",
                  'Código de estado:'+ response.data.error_msg,
                  "warning"
                );
      return null;
    }      
  } catch (error) {
    console.error('Error al cargar servicio:', rutaObtieneExamenes, 'Descripción de error:', error);
    isLoading.value = false;
    Swal.fire(
                  "Error al obtener datos de examenes",
                  'Código de estado:'+ error,
                  "error"
                );
    return null;
  }
};

// Función para volver a la búsqueda
const volverABusqueda = () => {
  // Resetear el captcha antes de navegar (si existe en la página actual)
  if (typeof grecaptcha !== 'undefined') {
    try {
      grecaptcha.reset();
    } catch (error) {
      //console.log('No hay captcha para resetear en esta página');
    }
  }
  
  // Navegar a la página principal
  router.push('/principal');
};

</script>

<template>
  <div class="container mx-auto mb-10">
    <!-- Spinner de carga -->
    <Transition name="fade">
      <div v-if="isLoading" class="flex flex-col items-center justify-center min-h-[50vh]">
        <div class="spinner-container">
          <div class="spinner"></div>
        </div>
        <h2 class="text-2xl text-gray-600 mt-6 animate-pulse">Cargando historial de episodios...</h2>
        <p class="text-gray-500 mt-2">Por favor espera mientras obtenemos la información</p>
      </div>
    </Transition>

    <!-- Contenido principal cuando ya cargó -->
    <Transition name="fade">
      <div v-if="!isLoading">
        <div class="flex justify-between items-center mb-5 mt-10">
          <h1 class="text-3xl text-center flex-1">Historial de Episodios</h1>
        </div>
        
        <div class="overflow-x-auto" v-if="persona.value">
      <div class="overflow-x-auto shadow rounded-xl" >
      <table class="min-w-full bg-white border border-gray-200">
        <thead class="bg-[#CC0066] text-white">
          <tr>
            <th class="w-1/12 px-4 py-2 border-b border-gray-200">Expediente</th>
            <th class="w-1/12 px-4 py-2 border-b border-gray-200">CURP</th>
            <th class="w-1/12 px-4 py-2 border-b border-gray-200">RFC</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-200">Nombre</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-200">Apellido 1</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-200">Apellido 2</th>
          </tr>
        </thead>
        <tbody class="text-center">
          <tr >
            <td class="border-t border-gray-200 px-4 py-2">{{ persona.value.expedienteId }}</td>
            <td class="border-t border-gray-200 px-4 py-2">{{ persona.value.curp }}</td>
            <td class="border-t border-gray-200 px-4 py-2">{{ persona.value.rfc }}</td>
            <td class="border-t border-gray-200 px-4 py-2">{{ persona.value.nombre }}</td>
            <td class="border-t border-gray-200 px-4 py-2">{{ persona.value.apellidoPaterno }}</td>
            <td class="border-t border-gray-200 px-4 py-2">{{ persona.value.apellidoMaterno }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="overflow-x-auto shadow rounded-xl mt-20">
      <table class="min-w-full bg-white" v-if="persona.value && episodiosHistoricos.value">
        <thead>
          <tr class="bg-gray-200">
            <th class="w-1/12 px-4 py-2 border-b border-gray-300">Episodio</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Tipo</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Transporte</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Categoría</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Puesto</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Motivo</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Resultado</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Vigencia inicio</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Vigencia fin</th>
            <th class="w-2/12 px-4 py-2 border-b border-gray-300">Módulo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(episodio, index) in episodiosHistoricos.value" :key="episodio.numeroExamen" class="gap-0 text-xs hover:font-bold  " :style="{ backgroundColor: index % 2 === 1 ? '#f7fafc' : 'white' }">
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.numeroExamen"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="tipoExamenDesc(episodio.tipoExamen)"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.nombreModoTransporte"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.nombreCategoria"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.nombrePuesto"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.nombreMotivo"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.resultadoExamen?'APTO':'NO APTO'"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.fechaInicioVigencia?.split(' ')[0]"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.fechaFinVigencia?.split(' ')[0]"></td>
            <td class="border-t border-gray-200 px-4 py-2" v-text="episodio.nombreModulo"></td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    
    <!-- Botón centrado al final -->
    <div class="flex justify-center mt-8" v-if="persona.value || !persona.value">
      <button 
        @click="volverABusqueda"
        class="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition-colors duration-200 flex items-center gap-2 text-lg"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        Realizar Nueva Búsqueda
      </button>
    </div>
    
    <div v-else>
      <h1 class=" text-lg mb-5 mt-10 text-center">Este usuario no ha iniciado episodios en el nuevo sistema</h1>
    </div>
    
    </div> <!-- Cierre del contenido principal -->
    </Transition>
  </div> <!-- Cierre del container -->
</template>

<style scoped>
.loader {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #3498db;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 1s linear infinite;
}

/* Spinner principal más grande y atractivo */
.spinner-container {
  position: relative;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #CC0066;
  border-radius: 50%;
  animation: spin 2s linear infinite;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Animación de pulsación para el texto */
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Efecto de entrada suave */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>